(() => {
  if (window.hvHeaderInitialized) return;
  window.hvHeaderInitialized = true;
  const instances = new Map();
  function init(header) {
    if (instances.has(header)) return;
    const events = new AbortController();
    const listen = (target, type, handler) => target.addEventListener(type, handler, { signal: events.signal });
    const updateHeaderBottom = () => document.documentElement.style.setProperty(
      "--site-header-bottom", Math.max(0, header.getBoundingClientRect().bottom) + "px",
    );
    updateHeaderBottom();
    const observer = new ResizeObserver(updateHeaderBottom);
    observer.observe(header);
    const announcement = header.querySelector("[data-header-announcement]");
    const messages = [...header.querySelectorAll(".site-header__announcement-message")];
    let activeMessage = 0;
    const showMessage = () => messages.forEach((message, index) => {
      message.classList.toggle("is-active", index === activeMessage);
      message.setAttribute("aria-hidden", String(index !== activeMessage));
    });
    showMessage();
    const promoTimer = messages.length > 1 ? window.setInterval(() => {
      if (document.hidden || innerWidth >= 990 || announcement?.contains(document.activeElement)) return;
      activeMessage = (activeMessage + 1) % messages.length;
      showMessage();
    }, 5000) : null;
    const button = header.querySelector("[data-menu-toggle]");
    const menu = header.querySelector("[data-mobile-menu]");
    let previousOverflow = "";
    function closeMenu() {
      if (!header.classList.contains("is-menu-open")) return;
      header.classList.remove("is-menu-open");
      button?.setAttribute("aria-expanded", "false");
      button?.setAttribute("aria-label", "Open menu");
      if (menu) menu.inert = true;
      document.body.style.overflow = previousOverflow;
    }
    if (menu) menu.inert = true;
    if (button) listen(button, "click", () => {
      if (header.classList.contains("is-menu-open")) closeMenu();
      else {
        previousOverflow = document.body.style.overflow;
        header.classList.add("is-menu-open");
        button.setAttribute("aria-expanded", "true");
        button.setAttribute("aria-label", "Close menu");
        if (menu) menu.inert = false;
        document.body.style.overflow = "hidden";
      }
    });
    listen(document, "keydown", event => {
      if (event.key === "Escape" && header.classList.contains("is-menu-open")) {
        closeMenu();
        button?.focus();
      }
    });
    listen(window, "resize", () => {
      updateHeaderBottom();
      if (innerWidth >= 990) closeMenu();
    });
    instances.set(header, () => { closeMenu(); clearInterval(promoTimer); observer.disconnect(); events.abort(); instances.delete(header); });
  }
  const scan = () => document.querySelectorAll(".site-header").forEach(init);
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", scan);
  else scan();
  document.addEventListener("shopify:section:load", scan);
  document.addEventListener("shopify:section:unload", event => {
    for (const [header, cleanup] of instances) if (event.target.contains(header)) cleanup();
  });
})();
